<div *ngIf="allPages > 1" class="page-pagination">
    <nav aria-label="Nawigacja między stronami">
        <ul class="pagination justify-content-center">

            <li [class.disabled]="currentPage === 1" class="page-item page-item-prev">
                <a (click)="changePage(currentPage-1)" attr.data-page="{{currentPage - 1}}" class="page-link"
                   data-collection="archive">Poprzednia</a>
            </li>

            <ng-container *ngFor="let page of list">
                <li [class.active]="currentPage === page" [class.disabled]="page === '...'" class="page-item">
                    <a (click)="changePage(page)" attr.data-page="{{page}}" class="page-link"
                       data-collection="archive">{{page}}</a>
                </li>
            </ng-container>

            <li [class.disabled]="currentPage === maxPage" class="page-item page-item-next">
                <a (click)="changePage(currentPage+1)" attr.data-page="{{currentPage+1}}" class="page-link"
                   data-collection="archive">Następna</a>
            </li>

            <!-- <li class="page-item disabled"><span class="page-link" href="#">&hellip;</span></li> -->
        </ul>
    </nav>
</div>
